import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Aura from '@primeuix/themes/aura';
import 'primeicons/primeicons.css';
import './style.css';

import App from './App.vue';
import { router } from './router';
import ar from './locales/ar.json';
import en from './locales/en.json';

const savedLocale = (localStorage.getItem('locale') as 'ar' | 'en') ?? 'en';
document.documentElement.lang = savedLocale;
document.documentElement.dir = savedLocale === 'ar' ? 'rtl' : 'ltr';

const i18n = createI18n({
    legacy: false,
    locale: savedLocale,
    fallbackLocale: 'en',
    messages: { ar, en },
});

createApp(App)
    .use(createPinia())
    .use(router)
    .use(i18n)
    .use(PrimeVue, {
        theme: { preset: Aura, options: { darkModeSelector: '.dark', cssLayer: false } },
        ripple: true,
    })
    .use(ToastService)
    .mount('#app');
